<template>
  <div class="persons">
    <el-row justify="center" class="persons-header">
      <el-col :span="16" align="center">
        <div>
          <h1 class="pt-3 mb-3">
            <strong>Somos Pixeon</strong>
          </h1>
        </div>
        <div class="pt-3" v-html="data.heading"></div>
      </el-col>
    </el-row>

    <el-row justify="center" align="center" class="purpose mt-5">
      <el-col :span="8" justify="center" class="purpose-icon">
        <h1>Nosso <strong>Propósito</strong></h1>
        <div class="pt-3" v-html="data.pourpose"></div>
      </el-col>
      <el-col :span="8" class="purpose-icon" align="center">
        <figure>
          <img
            class="icon"
            alt="Vue logo"
            src="../../assets/images/purpose-icon.png"
          />
        </figure>
      </el-col>
    </el-row>

    <el-row :gutter="20" justify="center" class="mission">
      <el-col :span="8" align="right">
        <div class="mission-box right">
          <h1 class="mb-2">
            Nossa <span><strong>Missão</strong></span>
          </h1>
          <div v-html="data.mission"></div>
        </div>
      </el-col>
      <el-col :span="8" align="left">
        <div class="mission-box left">
          <h1 class="mb-2">
            Nossa <span><strong>Visão</strong></span>
          </h1>
          <div v-html="data.vision"></div>
        </div>
      </el-col>
    </el-row>

    <el-row justify="center" class="our-values">
      <el-col align="center">
        <h3>Nossos Valores</h3>
      </el-col>
    </el-row>

    <el-row justify="center" class="our-values graph spacing">
      <el-col align="center">
        <div>
          <figure>
            <img
              class="icon"
              alt="Vue logo"
              :src="data.valores_img"
            />
          </figure>
        </div>
      </el-col>
    </el-row>

    <el-row v-if="false" justify="center" class="our-values">
      <el-col align="center">
        <h3>COMO VIVEMOS A NOSSA CULTURA</h3>
      </el-col>
    </el-row>

    <el-row justify="center" class="how-we-see graph" v-if="false">
      <el-col align="center" class="spacing">
        <div>
          <figure>
            <img
              class="icon"
              alt="Vue logo"
              :src="data.nossa_cultura_img"
            />
          </figure>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { ref, onBeforeMount } from 'vue'
import { firebaseRoutes } from '../../config/firebase.conf'

export default {
  name: 'Culture',
  setup () {
    const data = ref({})

    onBeforeMount(async () => {
      data.value = await axios.get(firebaseRoutes.cultura).then((response) => {
        const result = []
        for (const id in response.data) {
          result.push({
            id: id,
            heading: response.data[id].heading,
            pourpose: response.data[id].pourpose,
            mission: response.data[id].mission,
            vision: response.data[id].vision,
            valores_img: response.data[id].valores_img,
            nossa_cultura_img: response.data[id].nossa_cultura_img
          })
        }
        return result[0]
      })
    })

    return {
      data
    }
  }
}
</script>

<style lang="scss">
@import "~@/styles/variables.scss";

.persons-header{
  p{
    margin-bottom: 1.8rem;
    font-size: 1.4rem;
    strong{
      font-size: 1.6rem;
    }
  }

  em {
    color: $light-blue;
    display: inline;
    font-size: 1.6rem;
    font-weight: normal;
  }
}
.purpose {
  min-height: 50rem;
  padding: 6rem 0;
  background-image: url(../../assets/images/purpose-bg.png);
  background-size: cover;
  background-position: top;
  img {
    max-height: 25rem;
  }

  h1 {
    color: $white;
    font-size: 6.2rem;
    line-height: 7rem;
  }

  h3 {
    color: $white;
    padding-top: 1.4rem;
    font-size: 3.8rem;
    line-height: 5rem;
    display: block;
    text-transform: none;
  }
}

.purpose-icon {
  align-self: center;
}

.mission {
  margin-top: 8.5rem;
}
.mission-box {
  min-height: 32rem;
  max-width: 37rem;
  background-color: $white;
  margin-bottom: 10rem;
  h1 {
    letter-spacing: 0.5rem;
  }
  span {
    display: block;
  }
}

.mission-box.right {
  padding: 2rem 2rem 4rem 12rem;
}

.mission-box.left {
  padding: 2rem 12rem 4rem 2rem;
}

.our-values {
  text-transform: uppercase;
  margin-bottom: 6rem;
  h3 {
    font-size: 3rem;
  }
}

.our-values.graph {
  img {
    max-height: 60rem;
  }
}

.how-we-see.graph {
  img {
    max-height: 55rem;
  }
}

.spacing {
  margin-bottom: 15rem;
}
</style>
